import { Box, Card, CardActionArea, Stack, useTheme } from "@mui/material";
import { BrandColorPalette } from "../../../../utils/getColorMapping";
import ColorSwatch from "./ColorSwatch";

type InternBrandStylePaletteItemProps = {
  index?: number;
  palette: BrandColorPalette;
  variant?: "minimal" | "default";
  selectable?: boolean;
  isSelected?: boolean;
  onClick?: () => void;
  size?: "small" | "large";
};

const InternBrandStylePaletteItem = ({
  index,
  palette,
  variant = "default",
  selectable = false,
  isSelected = false,
  onClick,
  size = "small",
}: InternBrandStylePaletteItemProps) => {
  const theme = useTheme();

  const spacing = size === "large" ? 2 : 1;

  const renderSwatch = (color: string, label: string) => (
    <ColorSwatch
      color={color}
      size={size}
      label={variant === "minimal" ? undefined : label}
      copyOnClick={!selectable}
    />
  );

  const renderPalettes = () => (
    <Stack direction="row" spacing={spacing} justifyContent="center" flex={1}>
      {renderSwatch(palette.primary, "Primary")}
      {renderSwatch(palette.accent1, "Accent 1")}
      {renderSwatch(palette.accent2, "Accent 2")}
      {renderSwatch(palette.accent3, "Accent 3")}
    </Stack>
  );

  const content = renderPalettes();

  if (!selectable) {
    return (
      <Card
        sx={{
          p: size === "large" ? 3 : 2,
          backgroundColor: "white",
          border: "1px solid #E0E0E0",
          borderRadius: "12px",
          minHeight: size === "large" ? "200px" : "auto",
        }}
      >
        {content}
      </Card>
    );
  }

  return (
    <Card
      sx={{
        mb: 2,
        border: isSelected
          ? `2px solid ${theme.palette.primary.main}`
          : "1px solid #E0E0E0",
        borderRadius: "8px",
        backgroundColor: isSelected ? "#F8F9FF" : "white",
        transition: "all 0.2s ease",
        "&:hover": {
          borderColor: theme.palette.primary.main,
          backgroundColor: "#F8F9FF",
        },
      }}
    >
      <Stack direction="row" alignItems="center">
        {index !== undefined && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 24,
              height: 24,
              borderRadius: "50%",
              backgroundColor: theme.palette.primary.main,
              color: "white",
              fontSize: "12px",
              fontWeight: 600,
              marginLeft: 2,
              marginRight: 1,
              flexShrink: 0,
            }}
          >
            {index + 1}
          </Box>
        )}
        <CardActionArea onClick={onClick} sx={{ p: 2, flex: 1 }}>
          {content}
        </CardActionArea>
      </Stack>
    </Card>
  );
};

export default InternBrandStylePaletteItem;
